import { render, staticRenderFns } from "./worksetuptable.vue?vue&type=template&id=46d6d34f&scoped=true&"
import script from "./worksetuptable.vue?vue&type=script&lang=js&"
export * from "./worksetuptable.vue?vue&type=script&lang=js&"
import style0 from "./worksetuptable.vue?vue&type=style&index=0&id=46d6d34f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6d34f",
  null
  
)

export default component.exports